module.exports = __webpack_public_path__ + "7c0b997fd9bbd0f9707cc66fdaa63415.svg";